import "./Slider.css"
import { Link } from "react-router-dom";
import pdf from "./amahle-amashenge-company-2021.pdf";

const Slider = ({redirectToTop}) => {
    return (  
        <>
            <div className="container">
                <h1>Amahle-Amashenge</h1>
                <p>Amahle-Amashenge Holdings (Pty) Ltd is a local conglomerate entity, which has interest in diverse industries. Amahle-Amashenge Holdings (Pty) Ltd is made up of a group of local youth with tacit and explict skills.</p>
                <button className="btn btn4"><Link to="/contact" onClick={redirectToTop}>Click to Inquire</Link></button>
                <a href={pdf} download="Amahle-Amashenge-Profile" target="_blank"><button className="btn btn4">Download Our Profile</button></a>
                <div className="contact">
                    <p>Email: admin@amahle-amashenge.co.za</p>
                    <p>Phone: (067) 162 5597</p>
                </div>
            </div>
       </>
    );
}
 
export default Slider;